import Vue from 'vue'
const directiveName = "password";

export default {
	install () {
		Vue.directive(directiveName,{
			bind (el) {
				el.addEventListener('focus',()=>{
					el.setAttribute('type','password');
				})
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/directive/disabledPassword.js